import styled from '@xstyled/styled-components';

import { TextField } from './TextField';

export const SearchInput = styled(TextField)`
  && .ms-TextField-fieldGroup {
    height: 3rem;
  }
`;
